function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.71082 0H35.2949C36.7489 0 38.1433 0.598665 39.1715 1.6643C40.1996 2.72993 40.7772 4.17523 40.7772 5.68227V20.835C40.7772 22.342 40.1996 23.7873 39.1715 24.8529C38.1433 25.9186 36.7489 26.5172 35.2949 26.5172H22.5796L10.8036 35.624C10.5319 35.8342 10.209 35.9618 9.87129 35.9927C9.53353 36.0235 9.19415 35.9564 8.89111 35.7988C8.58807 35.6411 8.33331 35.3992 8.15535 35.1001C7.97738 34.8009 7.88321 34.4564 7.88338 34.105V26.5172C6.91405 26.5172 5.98442 26.1181 5.299 25.4077C4.61358 24.6973 4.22852 23.7337 4.22852 22.7291V5.68227C4.22852 4.17523 4.80611 2.72993 5.83424 1.6643C6.86238 0.598665 8.25682 0 9.71082 0ZM27.9852 17.0468C28.9545 17.0468 29.8841 16.6477 30.5695 15.9373C31.255 15.2268 31.64 14.2633 31.64 13.2586C31.64 12.2539 31.255 11.2904 30.5695 10.58C29.8841 9.86955 28.9545 9.47044 27.9852 9.47044C27.0158 9.47044 26.0862 9.86955 25.4008 10.58C24.7154 11.2904 24.3303 12.2539 24.3303 13.2586C24.3303 14.2633 24.7154 15.2268 25.4008 15.9373C26.0862 16.6477 27.0158 17.0468 27.9852 17.0468ZM17.0206 17.0468C17.9899 17.0468 18.9195 16.6477 19.6049 15.9373C20.2904 15.2268 20.6754 14.2633 20.6754 13.2586C20.6754 12.2539 20.2904 11.2904 19.6049 10.58C18.9195 9.86955 17.9899 9.47044 17.0206 9.47044C16.0512 9.47044 15.1216 9.86955 14.4362 10.58C13.7507 11.2904 13.3657 12.2539 13.3657 13.2586C13.3657 14.2633 13.7507 15.2268 14.4362 15.9373C15.1216 16.6477 16.0512 17.0468 17.0206 17.0468Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.228516,
  y: 0,
  width: 44.5487,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ead7b1e1.svg";
export { ForwardRef as ReactComponent };